/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Open_ClubInputs */

const en_us2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open club`)
};

const pt_br2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir clube`)
};

const es_419_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir club`)
};

const pt_pt2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir clube`)
};

const fr_fr2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le club`)
};

const de_de2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club öffnen`)
};

const it_it2_clubs_open_club = /** @type {(inputs: Clubs_Open_ClubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il club`)
};

/**
* | output |
* | --- |
* | "Open club" |
*
* @param {Clubs_Open_ClubInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_open_club = /** @type {((inputs?: Clubs_Open_ClubInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Open_ClubInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_open_club(inputs)
	if (locale === "es-419") return es_419_clubs_open_club(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_open_club(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_open_club(inputs)
	if (locale === "de-DE") return de_de2_clubs_open_club(inputs)
	if (locale === "it-IT") return it_it2_clubs_open_club(inputs)
	return en_us2_clubs_open_club(inputs)
});
export { clubs_open_club as "clubs.open_club" }